<template>
	<div class="personBox">
		<div class="iconBtn" v-if="userInfo && userInfo.superUserId" @click="handleLogout">
			{{ $t('personal.loginOut') }}
		</div>
		<div class="iconBtn" v-else @click="handleLogin">
			{{ $t('personal.loginBtn') }}
		</div>
		
		<!-- 签到区域 - 青色背景区 -->
		<div class="signBox">
			<div class="signList">
				<div class="signItem" v-for="(item, index) in signList" :key="index">
					<div class="signItemBg" :class="{ signed: item.isSign, canGet: item.canGet }" @click="handleSignClick(item)">
						<img :src="require('@/assets/images/kr/vipPropHalf.png')" class="signPropImg" />
					</div>
					<img class="signDotImg" :src="item.isSign ? dotTImg : dotWImg" />
				</div>
			</div>
			<div class="signBarBg">
				<template v-for="(item, index) in signList" :key="'bar'+index">
					<img v-if="index < signList.length - 1" class="signBarImg" :src="signList[index + 1].isSign ? signTImg : signWImg" />
				</template>
			</div>
			<div class="signLabels">
				<span class="signLabelTxt" v-for="(item, index) in signList" :key="'lbl'+index">{{ item.label || (item.isSign ? '已签' : '') }}</span>
			</div>
		</div>
		
		<div class="cardBox">
			<div class="avatar">
				<img v-if="userInfo.picture" :src="userInfo.picture" :onerror="imgError">
				<img v-else src="~@/assets/images/common/avatar_temp.png" />
			</div>
			<div class="vipIcon">
				<span style="font-size: 0.66rem;" v-if="vipLevel == 'vip0'" >
					<router-link style="color: #f4f4f4;" to="/vipInfo">{{ $t('personal.commonUser') }}</router-link>
				</span>
				<span v-else>
					<router-link style="color: #f4f4f4;" to="/vipInfo">{{vipLevel}}</router-link>
				</span> 
			</div>
			<div class="vipDetail">
				<router-link to="/vipInfo">{{ $t('personal.vipDetail') }}＞</router-link>
			</div>
			<div class="vipBtnBox">
				<router-link class="vipBtn" to="/vipPage">{{ $t('personal.vipPage') }}＞</router-link>
			</div>
			<van-cell center :label="`${$t('personal.googleEmail')}：${userInfo.email || '***'}`" is-link to="/infos">
				<template #title>
				    <span class="titleLabel">{{ $t('personal.platId') }}：</span>
				    <span class="titleVal">{{ userInfo.superUserId || '***' }}</span>
				  </template>
			  </van-cell>
			  <div class="lineBox">
				  <div class="coinLine">
				  	<i class="coinIcon"></i>
				  	<p>{{ $t('pay.paygmCoin') }}：{{ userInfo.payGmCoin || 0 }}</p>
				  	<div class="rechargeBtn" @click="handleRecharge">{{ $t('pay.recharge') }}</div>
				  </div>
				<div class="coinLine">
					<i class="coinIcon"></i>
					<p>{{ $t('pay.gmCoin') }}：{{ userInfo.platCoin || 0 }}</p>
					<!-- <div class="rechargeBtn" @click="handleRecharge">{{ $t('pay.recharge') }}</div> -->
				</div>
				<div class="coinLine">
					<i class="couponIcon"></i>
					<p>{{ $t('personal.myPlatCoupons') }}：{{ userInfo.gmCoupon || 0 }}</p>
					<div class="rechargeBtn" @click="handleRecharge">{{ $t('pay.recharge') }}</div>
				</div>
				<div class="coinLine">
					<p>{{ $t('personal.orderTitle') }}</p>
					<div class="rechargeBtn" @click="handleOrders">{{ $t('personal.join') }}</div>
				</div>
			  </div>
		</div>
		
		<div class="footDesc">
			<van-cell-group :border="false">
			  <van-cell :title="$t('footer.gmRules')" is-link to="/rules" />
			</van-cell-group>
			<van-cell-group :border="false">
			  <van-cell :title="$t('footer.useManual')" is-link to="/infos" />
			</van-cell-group>
		</div>
		
		<!-- 登录 -->
		<Login :showLogin="openLogin" @loginSuccess="loginSuccess" />
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed } from 'vue'
	import { useRouter } from 'vue-router'
	import useUserStore from '@/store/modules/user'
	import useConfigStore from '@/store/modules/config'
	import Login from '@/components/login'
	import { propUserLogin,getVipInfo,getUserMallInfo,getCoins,doSignin } from '@/api/gm.js'
	
	const { proxy } = getCurrentInstance();
	const isMobile = computed(() => {
		return useConfigStore().isMobile
	})
	const userInfo = computed(() => {
		return useUserStore().userInfo
	})
	const router = useRouter();
	const openLogin = ref(false)
	const vipLevel = ref('VIP')
	const signList = ref([
		{ label: '1일', isSign: false, canGet: false, giftId: 0 },
		{ label: '2일', isSign: false, canGet: false, giftId: 1 },
		{ label: '3일', isSign: false, canGet: false, giftId: 2 },
		{ label: '4일', isSign: false, canGet: false, giftId: 3 },
	])
	const signProgress = ref(0)
	let lastSignTime = 0
	const handleSignClick = (item) => {
		if(item.isSign) return
		const now = Date.now()
		if(now - lastSignTime < 2000) return
		lastSignTime = now
		doSignin(item.giftId).then((res) => {
			if(res.code === 200){
				proxy.$toast('签到 성공')
				location.reload()
			} else {
				proxy.$toast(res.msg || '签到 실패')
			}
		})
	}
	const signTImg = require('@/assets/images/kr/vip_sign_t.png')
	const signWImg = require('@/assets/images/kr/vip_sign_w.png')
	const dotTImg = require('@/assets/images/kr/vip_d.png')
	const dotWImg = require('@/assets/images/kr/vip_w.png')
	const handleLogin = () => {
		openLogin.value = true
	}
	const loginSuccess = () => {
		getVipInfo(userInfo.value.superUserId).then((res)=>{
			vipLevel.value = res.data.vipLevel
		})
		openLogin.value = false
	}
	const handleLogout = () => {
		useUserStore().close().then(() => {
			vipLevel.value = 'VIP'
			proxy.$toast('Success')
		})
	}
	const handleRecharge = () => {
		router.push({ path:'/recharge' });
	}
	const handleOrders = () => {
		router.push({ path:'/orders' });
	}
	const imgError = () => {
		var img = event.srcElement;
		img.src = require('@/assets/images/common/avatar_temp.png');
		img.onerror = null;
	}
	const toVipDetail = () =>{
		console.log(1111);
	}
	const testAccount = ref(['364431168@qq.com','y1287359820@gmail.com'])
	const test = () => {
		if(userInfo.value && testAccount.value.includes(userInfo.value.email)){
			return true
		}else{
			return false
		}
	}
	onMounted(() => {
		const query = router.currentRoute.value.query
		if(query.token){
			propUserLogin(query.token).then((res) => {
				console.log(res)
				useUserStore().setInfo(res.data).then((datas) => {
					// logEvent(analytics, 'login_gm', { des: '盒子登录' })
					proxy.$toast('Success')
					
				})
			})
		}
		if(userInfo.value.picture){
			getVipInfo(userInfo.value.superUserId).then((res)=>{
				vipLevel.value = res.data.vipLevel
			})
		}
		getInfo()
	})
	const getInfo = () => {
		if(useUserStore().userToken){
			getUserMallInfo().then((res) => {
				useUserStore().setCoinInfo(res.data)
			})
			getCoins().then((res) => {
				if(res.code === 200 && res.data){
					const list = res.data.gift || []
					list.forEach((item) => {
						const idx = item.gift_id
						if(signList.value[idx]){
							signList.value[idx].isSign = item.gift_status === '2'
							signList.value[idx].canGet = item.gift_status === '1'
							signList.value[idx].giftId = item.gift_id
						}
					})
					const signedCount = list.filter(item => item.gift_status === '2').length
					signProgress.value = Math.round((signedCount / list.length) * 100) || 0
				}
			})
		}
		
	}
	watch(isMobile, (newVal, oldVal) => {
		if(!newVal){
			router.push({ path:'/' });
		}
	},{ immediate: true })
</script>


<style lang="less" scoped>
	a{
		color: #000;
	  &::after{
	      content: '';display: block;width: 0;height: 2px;background: #51bac0;position: absolute;bottom: 0;left: 50%;transition: all 0.3s ease-in-out;
	  }
	  &:hover{
	      color: #51bac0;
	      &::after{width: 100%;left: 0;}
	    }
	  &.router-link-active{
	      color: #51bac0;
	      &:hover{color: #000000;}
	    }
	  
	}
</style>
<style lang="less" scoped>
	.signBox{
			position: absolute;top: 3.2rem;left: 50%;transform: translateX(-50%);z-index: 10;
			width: 90%;
			.signList{display: flex;justify-content: space-between;padding: 0 0.5rem;position: relative;z-index: 2;}
			.signItem{display: flex;flex-direction: column;align-items: center;flex: 1;}
			.signItemBg{
				width: 2.8rem;height: 2.8rem;display: flex;align-items: center;justify-content: center;
				position: relative;background: url('~@/assets/images/kr/vip_sign_bg.png') no-repeat center / contain;
				&.signed{background-image: url('~@/assets/images/kr/vip_sign.png');}
				&.canGet{background-image: url('~@/assets/images/kr/vip_get_bg.png');}
				.signPropImg{width: 1.4rem;height: 1.4rem;transform: translateY(-0.35rem);}
			}
			.signDotImg{width: 8px;height: 8px;margin-top: 0.25rem;flex-shrink: 0;}
			.signBarBg{
				display: flex;justify-content: space-between;align-items: center;
				padding: 0 calc(0.5rem + 1.4rem);margin-top: -6px;position: relative;z-index: 1;overflow: hidden;
				.signBarImg{height: 3px;flex: 1;max-width: calc(100% / 3);object-fit: cover;}
			}
			.signLabels{
				display: flex;padding: 0 0.5rem;margin-top: 0.15rem;
				.signLabelTxt{flex: 1;text-align: center;font-size: 0.55rem;color: rgba(255,255,255,0.85);}
			}
		}
	.personBox{
		background: url('~@/assets/images/common/personal_up_bg.png') no-repeat top;
		background-size: 100%;height: calc(100% - 40px);overflow-y: scroll;overflow-x: hidden;
		padding: 10rem 1rem 0;box-sizing: border-box;position: relative;
		.footDesc{
			background: #fff;width: calc(100% + 2rem);margin-left: -1rem;margin-top: 2rem;
			height: calc(100vh - 460px);overflow-y: scroll;min-height: 6.25rem;padding-bottom: 3.125rem;box-sizing: border-box;
		}
		.iconBtn{
			position: absolute;top: 1.25rem;right: 1rem;color: #fff;font-size: 0.9375rem;
		}
		.cardBox{
			width: 100%;border-radius: 0.5rem;background: #fff;position: relative;
			padding: 1.875rem 0 0;
			box-shadow: 0px 12px 18px 0px rgba(218, 218, 219, 0.80);
			padding-top:5rem;overflow:visible;
			.avatar{
				position: absolute;left: 1.875rem;top: -2rem;z-index: 111;
				width: 4rem;height: 4rem;border: 0.125rem solid #fff;border-radius: 50%;overflow: hidden;
				img{
					width: 100%;
				}
			}
			.vipIcon{
				width: 4.2rem;
				height: 1.6rem;
				text-align: center;
				line-height:1.6rem;
				padding-left: 1.2rem;
				color: #f4f4f4;
				font-size: 0.8rem;
				position: absolute;
				left: 28%;
				top: 1%;
				background: url('~@/assets/images/common/vipLevelIcon.png') no-repeat center;
				background-size: 100%;
			}
			.vipDetail{
				font-size: 0.8rem;
				position: absolute;
				right:2%;
				line-height: 1.5rem;
				top: 2%;
				color: #000;
			}
			.vipBtnBox{
				position:absolute;right:-.5rem;top:2.5rem;z-index:10;overflow:hidden;
				.vipBtn{
					display:inline-block;font-size:.75rem;color:#000;background:url('~@/assets/images/kr/vipbg.png') no-repeat center/contain;padding:.25rem .9rem;border-radius:0;text-decoration:none;font-weight:normal;white-space:nowrap;line-height:1.3;overflow:hidden;
				}
			}
			.lineBox{
				padding: 0 1rem 1rem;box-sizing: border-box;margin: 0.75rem 0;
			}
			.coinLine{
				display: flex;align-items: center;justify-content: center;
				padding: 0.75rem 0.75rem;
				background: url('~@/assets/images/common/line_bg.png') no-repeat center;
				background-size: 100%;
				.coinIcon{
					display: inline-block;width: 1.25rem;height: 1.25rem;
					background: url('~@/assets/images/common/coin_icon.png') no-repeat center;
					background-size: 100%;flex-shrink: 0;margin-right: 0.3125rem;
				}
				.couponIcon{
					display: inline-block;width: 1.25rem;height: 1.25rem;
					background: url('~@/assets/images/common/gmcoupon.png') no-repeat center;
					background-size: 100%;flex-shrink: 0;margin-right: 0.3125rem;
				}
				p{
					flex: 1;font-size: 0.875rem;
				}
				.rechargeBtn{
					flex-shrink: 0;
					font-size: 0.875rem;
					background: linear-gradient(to right,#51BAC0,#85D6DA);color: #fff;
					padding: 0.25rem 1.25rem;border-radius: 0.3125rem;
				}
			}
			/deep/.van-cell:after{
				border-bottom: none;
			}
		}
	}
</style>